import { useExperimentBucket } from '@carvana/experiment';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { Experiments } from '~/contracts/srp';

export default function useTrackRendered(
  experimentName: keyof Experiments,
  condition: boolean = true,
  customAttributes: any = {}
) {
  const experimentBucket = useExperimentBucket(experimentName);
  const trackEvent = useTrackEvent();

  useEffectOnce(
    () => {
      const eventName = `${experimentName} ${experimentBucket} rendered`;

      trackEvent(eventName, customAttributes);
      datadogRum.addAction(eventName, customAttributes);
    },
    [customAttributes, experimentBucket, experimentName, trackEvent],
    condition && Boolean(experimentBucket)
  );
}
